import { createFileRoute } from "@tanstack/react-router";
import LeistungenPage from "@/pages/LeistungenPage";
import { buildRouteHead } from "@/lib/route-head";
import { faqSchema, serviceListSchema } from "@/lib/schema";
import { services } from "@/data/services";
import { leistungenFaq } from "@/data/leistungenFaq";

export const Route = createFileRoute("/leistungen/")({
  head: () =>
    buildRouteHead({
      title: "Leistungen | Webdesign, SEO & Hosting in Wernigerode",
      description:
        "Webdesign, SEO-Optimierung, Hosting und Buchungssysteme aus Wernigerode im Harz. Digitale Lösungen für Unternehmen in Sachsen-Anhalt.",
      path: "/leistungen",
      image: "/images/services/webdesign-1024.webp",
      imageAlt: "Leistungen für Webdesign, SEO und Hosting",
      imageWidth: 1024,
      imageHeight: 730,
      scripts: [
        serviceListSchema(
          services.map((s) => ({
            title: s.title,
            slug: s.slug,
            description: s.longDescription ?? s.description,
          })),
        ),
        faqSchema(leistungenFaq),
      ],
    }),
  component: LeistungenPage,
});
